/**
 * Medição (GA4 via GTM). O código só empurra eventos para o dataLayer; o GTM repassa ao GA4 com o
 * consentimento de estatísticas dado no banner. Nunca passe nome, e-mail, voto ou história.
 * Padrão do grupo: intello-knowledge-map/40-infra/05-medicao-analytics.md
 */

type Params = Record<string, string | number | undefined>;

// Vazio fora do build de produção (o ID vem do Dockerfile): o desenvolvimento local não suja o GA4.
const GTM_ID = import.meta.env.VITE_GTM_ID ?? '';

function dataLayer(): unknown[] {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer ?? [];
  return w.dataLayer;
}

export function track(event: string, params: Params = {}): void {
  if (typeof window === 'undefined') return;
  dataLayer().push({ event, ...params });
}

// O GTM entra pelo bundle, e não por snippet no index.html, porque a CSP não aceita script inline.
// O consent.js do <head> já rodou aqui e definiu o consentimento padrão.
export function loadTagManager(): void {
  if (!GTM_ID) return;
  dataLayer().push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}
